import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from '../../../apollo';
import { CreateArticleAssets, CreateArticleAssetsVariables } from './__generated__/CreateArticleAssets';

const CREATE_ARTICLE_ASSETS = gql`
  mutation CreateArticleAssets($articleId: ID!, $assets: [AssetInput!]!) {
    createArticleAssets(articleId: $articleId, assets: $assets) {
      success
      errors
    }
  }
`;

export const useCreateArticleAssetsMutation = () => {
  return useMutation<CreateArticleAssets, CreateArticleAssetsVariables>(CREATE_ARTICLE_ASSETS, {
    client: kmsClient
  });
};
